import React from "react"
import PropTypes from 'prop-types'

const Building = ({
  style = {},
  fill = "white",
  width = "100%",
  className = "building",
  viewBox = "0 0 20 20"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M9 8h2V6H9v2zm0 4h2v-2H9v2zm2 6v-4H9v4H6V5h8v13h-3zm7-2v2h-2V3h-5V0H9v3H4v15H2v-2H0v4h20v-4h-2z"
    />
  </svg>
)

Building.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Building
